module.exports = __webpack_public_path__ + "img/stylus-pencil.6db1c089.svg";